export enum FirestoreErrorCodes {
  PERMISSION_DENIED = "permission-denied",
}
